import GrandLayout from '../../layouts/GrandLayout/GrandLayout';
import GrandPageAnimatedSections from '../../features/GrandPage/GrandPageAnimatedSections/GrandPageAnimatedSections';
import { useSearchParams } from 'react-router-dom';
import { Modal, TextInput, Button, Loader } from '@mantine/core';
import { useRef, useState, useEffect, createRef } from 'react';
import showNotification from "../../utils/showNotification";
import axios from 'axios';
import PhoneInputField from '../../components/PhoneInputField/PhoneInputField';
import { useForm } from '@mantine/form';
import { isValidPhoneNumber } from 'react-phone-number-input';

export default function GrandPage() {

    const [searchParams] = useSearchParams();
    const utm_source = searchParams.get("utm_source")
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const hasShownModal = useRef(false);


    const handleFormSubmit = async (values) => {

        try {
            setIsLoading(true)
            const data = {
                channel: 'web-transferencias',
                message: `Mensaje recibido desde la página GranD:
             Nombre: ${values.name},
             Email: ${values.email},
             Teléfono: ${values.phone},
            `
            }
            await axios.post(`${process.env.REACT_APP_BACKEND_SERVER}/info/slack`, data)

            setShowModal(false);
            showNotification({
                message: "Vamos a estar en contacto contigo muy pronto.",
                status: "success",
                color: "green",
                title: "Operación exitosa!"
            })

        } catch (err) {
            console.error(err);
            showNotification({
                message: "Ha ocurrido un error y no hemos procesado el pedido. Por favor intenta nuevamente.",
                status: "success",
                color: "red",
                title: "Error"
            })
        } finally {
            setIsLoading(false)
        }
    };

    const ref = createRef()
    const form = useForm({
        initialValues: {
            name: '',
            email: '',
            phone: '',
        },

        validate: {
            phone: (value) => {
                if (typeof value === "string")
                    return !isValidPhoneNumber(value)
                else return true
            }
        },
    });

    useEffect(() => {
        if (utm_source && !hasShownModal.current) {
            hasShownModal.current = true;

            const timer = setTimeout(() => {
                setShowModal(true);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, []);

    return (
        <GrandLayout>
            <GrandPageAnimatedSections />

            <Modal opened={showModal} onClose={() => setShowModal(false)} styles={{
                root: {
                    background: "red"
                }
            }}>
                <h3
                    style={{ fontSize: 'var(--fs-body)', textAlign: 'center', marginBottom: '2rem' }}
                >¿Querés que te contemos cuáles son las promociones de lanzamiento y los beneficios que tenemos para vos?
                </h3>
                <p
                    style={{ fontSize: 'var(--fs-small)', textAlign: 'center', marginBottom: '2rem' }}
                >Completá este formulario y te lo enviamos por WhatsApp o email.</p>
                <form onSubmit={form.onSubmit((values) => handleFormSubmit(values))} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <TextInput
                        label="Nombre"
                        placeholder="Tu nombre"
                        {...form.getInputProps('name')}
                        styles={{
                            input: {
                                backgroundColor: 'transparent',
                                border: '1px solid #32BAD9'
                            }
                        }}
                        mb="sm"
                    />



                    <PhoneInputField
                        ref={ref}
                        name="phone"
                        styles={{input: {background: 'transparent', border: "1px solid #32BAD9"}}}
                        fieldError={form.errors.phone}
                        {...form.getInputProps("phone")}
                    />
                    <TextInput
                        label="Email"
                        placeholder="Tu email"
                        styles={{
                            input: {
                                backgroundColor: 'transparent',
                                border: '1px solid #32BAD9'
                            },
                          
                        }}

                        name="email"
                          {...form.getInputProps('email')}
                        mb="sm"
                    />

                    <Button my={20} type="submit" fullWidth color='#32BAD9'>
                        {isLoading ? <Loader/> : "Enviar"}
                    </Button>
                </form>
            </Modal>
        </GrandLayout>

    )
}